import type { CMSConfig } from '#types/config/components/cms'

export default {
  divider: '/'
} satisfies CMSConfig['secondaryNav']
